export default __webpack_public_path__ + "static/gallery-writing-dramatic-e3aa6ff2b5f4b3ba3d17e06e2330f407.png";